// auth actions
export const SET_TOKEN = "@auth/set-token";
